var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useState } from 'react';
import { connect } from 'react-redux';
import { ELSCommonUIConstants, ELSPageLoader, ELSTokenHelper } from '@els/els-ui-common-react';
import { HESI_NG_TARGET_PAGES } from 'reports/hesi-ng/constants/hesi-ng.constant';
import { appSelectors } from 'redux/ducks/app';
import { ASSIGNMENT_TYPES } from 'reports/cw/constants/report.constant';
import { courseSelectors } from 'reports/cw/redux/ducks/courses';
import { EXTERNAL_APP_INFO } from 'constants/externalApp.constant';
import { redirectToOutsideApp } from 'services/app-linking.service';
import { fetchAllEolsUserByEolsUserId } from 'services/user-management.service';
import { SystemType } from 'models';
import { getTokenSwitchCourse } from 'helpers/app-linking.helper';
var mapStateToProps = function (state) { return ({
    selectedCourseId: appSelectors.getSelectedCourse(state),
    courseSectionInfo: courseSelectors.getCourseSectionInfo(state),
    isBackToPreviousAppIconShown: appSelectors.getIsBackToPreviousAppIconShown(state),
    xLinkId: appSelectors.getLinkId(state),
    appLinkOutPostBody: appSelectors.getAppLinkOutPostBody(state),
    appLinkNavigationInfo: appSelectors.getAppLinkNavigationInfo(state),
    isLaunchedInNewTab: appSelectors.getIsLaunchedInNewTab(state)
}); };
export var getNewTokenParams = function (token, selectedCourseId) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, tokenUserId, tokenSessionId, allUserData, data, selectedCourseData;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = token === null || token === void 0 ? void 0 : token.user, tokenUserId = _a.userId, tokenSessionId = _a.sessionId;
                return [4 /*yield*/, fetchAllEolsUserByEolsUserId(tokenUserId, SystemType.EVOLVETYPE).catch(function (e) { return e; })];
            case 1:
                allUserData = _b.sent();
                data = allUserData.data;
                selectedCourseData = data
                    .flatMap(function (user) {
                    return user.courseSections.flatMap(function (course) {
                        var courseIsbns = course.entitlements.flatMap(function (entitlement) {
                            return entitlement.isbn;
                        });
                        return { courseIsbns: courseIsbns, courseId: course.id, userId: user.id };
                    });
                })
                    .filter(function (course) { return course.courseId === selectedCourseId; })[0];
                return [2 /*return*/, {
                        appId: ELSCommonUIConstants.appIds.PERFORMANCE_REPORT,
                        courseId: selectedCourseData.courseId,
                        isbns: selectedCourseData.courseIsbns,
                        sessionId: tokenSessionId,
                        userId: selectedCourseData.userId
                    }];
        }
    });
}); };
export default (function (WrappedComponent) {
    var LoadDataHOC = function (props) {
        var _a = useState(false), isRedirectToOutsideAppLoading = _a[0], setIsRedirectToOutsideAppLoading = _a[1];
        var handleRedirectToOutsideApp = function (linkConfig, options, assignmentType) { return __awaiter(void 0, void 0, void 0, function () {
            var selectedCourseId, appLinkOutPostBody, courseSectionInfo, xLinkId, appLinkNavigationInfo, isLaunchedInNewTab, _a, _b, data, otherOptions, finalCourseId, token, tokenIsbns, updatedLinkConfig, updatedOptions, newTokenParams, newToken, customBody;
            var _c, _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        selectedCourseId = props.selectedCourseId, appLinkOutPostBody = props.appLinkOutPostBody, courseSectionInfo = props.courseSectionInfo, xLinkId = props.xLinkId, appLinkNavigationInfo = props.appLinkNavigationInfo, isLaunchedInNewTab = props.isLaunchedInNewTab;
                        _a = options || {}, _b = _a.data, data = _b === void 0 ? {} : _b, otherOptions = __rest(_a, ["data"]);
                        finalCourseId = (data === null || data === void 0 ? void 0 : data.courseId) || selectedCourseId;
                        token = ELSTokenHelper.parseToken(ELSTokenHelper.getToken());
                        tokenIsbns = ((_c = token === null || token === void 0 ? void 0 : token.user) === null || _c === void 0 ? void 0 : _c.appParams).isbns;
                        updatedLinkConfig = linkConfig;
                        updatedOptions = options;
                        if (!((!tokenIsbns || tokenIsbns.length === 0) && !Object.keys(HESI_NG_TARGET_PAGES).includes(data === null || data === void 0 ? void 0 : data.targetPage))) return [3 /*break*/, 3];
                        return [4 /*yield*/, getNewTokenParams(token, finalCourseId)];
                    case 1:
                        newTokenParams = _g.sent();
                        if (!(newTokenParams.isbns.length > 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, getTokenSwitchCourse(newTokenParams)];
                    case 2:
                        newToken = _g.sent();
                        ELSTokenHelper.storeToken(newToken);
                        updatedOptions = { ignoreToken: false, headers: { Authorization: "Bearer ".concat(newToken) } };
                        updatedLinkConfig = __assign(__assign({}, updatedLinkConfig), { isIncludeLinkHash: true });
                        _g.label = 3;
                    case 3:
                        customBody = __assign(__assign(__assign({ keptAppLinkOutPostBody: appLinkOutPostBody, courseId: finalCourseId, courseSectionId: finalCourseId }, otherOptions), data), { 
                            // Honor a caller-supplied keptXLinkId first (e.g. the back-to-previous-app forward trip seeds
                            // the current Performance session). Otherwise seed the current link as the origin only when it
                            // is a genuine external-source -> Performance link we can return to: not a new-tab launch
                            // (source stays open in the other tab) and not a Performance-initiated link (its return endpoint
                            // loops back to Performance). Otherwise leave it unset so the back button resolves to the
                            // last-visited app via keptTargetApp.
                            keptXLinkId: (_f = (_d = data.keptXLinkId) !== null && _d !== void 0 ? _d : (_e = appLinkNavigationInfo === null || appLinkNavigationInfo === void 0 ? void 0 : appLinkNavigationInfo.outPostBody) === null || _e === void 0 ? void 0 : _e.keptXLinkId) !== null && _f !== void 0 ? _f : (!isLaunchedInNewTab && (appLinkNavigationInfo === null || appLinkNavigationInfo === void 0 ? void 0 : appLinkNavigationInfo.srcApp) !== EXTERNAL_APP_INFO.APP_LINKING.PERFORMANCE.APP_NAME ? xLinkId : undefined), 
                            // The app being navigated to; echoed back so a new-tab return (whose session carries no
                            // srcApp/targetApp) can still label and re-open the last-visited dashboard.
                            keptTargetApp: linkConfig.appName });
                        if (assignmentType === ASSIGNMENT_TYPES.SHADOW_HEALTH.id) {
                            customBody.courseSection = courseSectionInfo;
                        }
                        setIsRedirectToOutsideAppLoading(true);
                        return [4 /*yield*/, redirectToOutsideApp(updatedLinkConfig, __assign(__assign(__assign({}, updatedOptions), { data: customBody }), otherOptions))];
                    case 4:
                        _g.sent();
                        setIsRedirectToOutsideAppLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        return (<>
        {isRedirectToOutsideAppLoading && <ELSPageLoader />}
        <WrappedComponent {...props} onRedirectToOutsideApp={handleRedirectToOutsideApp}/>
      </>);
    };
    return connect(mapStateToProps)(LoadDataHOC);
});
